import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Card } from 'components';
import { PsButtonTuner, PsRadioTuner } from 'stencilSetup';
import { PUT_UNUM_EXIT_APP_KEY } from '../utils';
import { useApiMutation } from 'theSource/utils';
import { ErrorResponseDto } from 'theSource/types';
import { useConfigurationQuery } from 'theSource/queries';
import { UnumExitAppRequestDto, UnumExitAppResponseDto } from '../types';
import { ROUTES } from 'enrollment/app/routes';

export interface UnumApplicationOptionsProps {
  orgBenefitId: number;
  optionIndex: number;
  setOptionIndex: Dispatch<SetStateAction<number>>;
}

export const UnumApplicationOptions = ({
  orgBenefitId,
  optionIndex,
  setOptionIndex,
}: UnumApplicationOptionsProps) => {
  const { t } = useTranslation('enrollment.plugins');

  const navigate = useNavigate();

  const values = [
    {
      label: t('unum.Application.optionsLabel1'),
      value: '1',
    },
    {
      label: t('unum.Application.optionsLabel2'),
      value: '2',
    },
    {
      label: t('unum.Application.optionsLabel3'),
      value: '3',
    },
    {
      label: t('unum.Application.optionsLabel4'),
      value: '4',
    },
  ];

  const { configuration } = useConfigurationQuery();
  const apiHost = configuration?.apiHost;

  const { mutate: UnumExitAppRequest } = useApiMutation<
    UnumExitAppResponseDto,
    ErrorResponseDto,
    UnumExitAppRequestDto
  >({
    queryKey: PUT_UNUM_EXIT_APP_KEY,
    method: 'put',
    endpoint: `${apiHost}/v1/self_service/plugins/unum/process_exit_application/${orgBenefitId}`,
    onSuccess: (response) => {
      if (response.data) {
        switch (response.data.redirect.action) {
          case 'index':
            navigate(-1);
            break;
          case 'exit':
            navigate(`/enrollment/${ROUTES.enrollment.benefits.path}`);
            break;
          default:
            break;
        }
      }
    },
    showSuccessSnackbar: false,
  });

  const exitApplication = () => {
    UnumExitAppRequest({ opt: String(optionIndex) });
  };

  return (
    <Card
      additionalClasses="card"
      dataTestId="enrollment-unum-options-card"
      showBorder
    >
      <h4>{t('unum.Application.optionsTitle')}</h4>
      <div>
        <p>{t('unum.Application.optionsSub1')}</p>
      </div>
      <div className="mt-4">
        <p>{t('unum.Application.optionsSub1')}</p>
      </div>
      <div>
        {values.map((value, index) => {
          return (
            <PsRadioTuner
              key={value.value}
              label={value.label}
              name="unumOptions"
              value={value.value}
              inputId={'unumOptions_' + value.value}
              onClick={() => setOptionIndex(index)}
            />
          );
        })}
      </div>
      {optionIndex > 0 && (
        <PsButtonTuner
          buttonId="exit-application-btn"
          label={t('unum.Application.exitAppLabel')}
          level="primary"
          extraClass="mt-5"
          onClick={exitApplication}
        />
      )}
    </Card>
  );
};
